import {Component, Inject, OnInit} from '@angular/core';
import {Localiser} from "../../../services/localiser";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ConcentradorService} from "../../../services/concentrador.service";
import {concentrador} from "../../../models/concentrador";
import {zona} from "../../../models/zona";
import {plano} from "../../../models/plano";
import {UserService} from "../../../services/user.service";
import {PlanoService} from "../../../services/plano.service";
import {ZonaService} from "../../../services/zona.service";

@Component({
  selector: 'app-edit-concentrador',
  templateUrl: './edit-concentrador.component.html',
  styleUrls: ['./edit-concentrador.component.css']
})
export class EditConcentradorComponent implements OnInit {

  selectedConcentradorToEdit: concentrador;
  name: string;

  zonas: Array<zona> = [];
  planos: Array<plano> = [];
  showZonas = [];
  showPlanos = [];
  proyectoSelected = undefined;
  planoSelected = undefined;
  zonaSelected = undefined;

  concentradoresMantenimiento: Array<concentrador> = [];
  concentradorMantenimientoSelected = undefined;
  changingProyecto: boolean = false;

  // The gateway takes part in an OTA currently in progress, either as the main gateway of the
  // luminaires being updated or as the maintenance gateway performing the update itself.
  otaActive: boolean = false;
  // Status the gateway had when the modal was opened, used to restore it if the change is blocked
  activoOriginal: boolean = true;
  // Another gateway with the same project, PanID and channel is already active, so this inactive
  // one cannot be activated. Mirrors the check the backend does in ConcentradorService.updateInfo.
  activationBlocked: boolean = false;

  constructor(public localiser: Localiser, public dialogRef: MatDialogRef<EditConcentradorComponent>,
              @Inject(MAT_DIALOG_DATA) public data,
              private concentradorService: ConcentradorService, public user: UserService,
              private planoService: PlanoService, private zonaService: ZonaService) { }

  ngOnInit(): void {
    this.selectedConcentradorToEdit = this.concentradorService.getConcentradorToEdit();
    this.checkPlanoAndZonaSelected();
    this.name = this.selectedConcentradorToEdit.nombre;
    this.otaActive = this.selectedConcentradorToEdit.otaActive == true;
    this.activoOriginal = this.selectedConcentradorToEdit.activo;
    this.activationBlocked = this.checkActivationBlocked(this.data.allConcentradores);
    this.concentradoresMantenimiento = this.data.concentradores;
    this.concentradorMantenimientoSelected = this.concentradoresMantenimiento.find(concentrador =>
      concentrador.idDispositivo == this.selectedConcentradorToEdit.concentradorMantenimiento);
  }

  /**
   * An inactive gateway cannot be activated while another gateway of the same project is already
   * active on its PanID and channel, the backend rejects that update with a -2.
   */
  checkActivationBlocked(concentradores: Array<concentrador>): boolean {
    if (this.activoOriginal || concentradores == null) {
      return false;
    }
    return concentradores.some(concentrador =>
      concentrador.activo
      && concentrador.idDispositivo != this.selectedConcentradorToEdit.idDispositivo
      && concentrador.idProyecto == this.selectedConcentradorToEdit.idProyecto
      && concentrador.panId == this.selectedConcentradorToEdit.panId
      && concentrador.channel == this.selectedConcentradorToEdit.channel);
  }

  async checkPlanoAndZonaSelected() {
    this.zonas = [];
    this.planos = [];
    this.showZonas = [];
    this.showPlanos = [];

    await this.getPlanosAndZonas(); // Properly waits for data to load

    this.proyectoSelected = this.user.getProyectos().find(proyecto =>
      proyecto.idProyecto == this.selectedConcentradorToEdit.idProyecto
    );

    if (this.proyectoSelected) {
      this.planoSelected = this.planos.find(plano =>
        plano.idPlano == this.selectedConcentradorToEdit.idPlano
      );

      this.showPlanos = this.planos.filter(plano =>
        plano.idProyecto == this.proyectoSelected.idProyecto
      );

      if (this.planoSelected) {
        this.zonaSelected = this.zonas.find(zona =>
          zona.id == this.selectedConcentradorToEdit.idZona
        );

        this.showZonas = this.zonas.filter(zona =>
          zona.idPlano == this.planoSelected.idPlano
        );
      }
    }
  }

  async getPlanosAndZonas(): Promise<void> {
    // Load zonas
    const zonasResp = await this.zonaService.getAll().toPromise();
    this.zonas = zonasResp as zona[];

    // Load planos for all proyectos
    const proyectos = this.user.getProyectos();

    const planoRequests: Promise<plano[]>[] = proyectos.map(pro =>
      this.planoService.getByIdProyecto(pro.idProyecto).toPromise() as Promise<plano[]>
    );

    const allPlanos: plano[][] = await Promise.all(planoRequests);

    this.planos = ([] as plano[]).concat(...allPlanos); // flatten safely
  }

  selectProyecto(event) {
    this.proyectoSelected = this.user.getProyectos().find(proyecto => proyecto.idProyecto == event.value.idProyecto);
    this.planoSelected = undefined;
    this.zonaSelected = undefined;
    this.showZonas = [];
    this.showPlanos = this.planos.filter(plano => {
      return plano.idProyecto == this.proyectoSelected.idProyecto;
    });

    // Show warning if the project is changed
    this.changingProyecto = this.selectedConcentradorToEdit.idProyecto != "-1"
      && this.selectedConcentradorToEdit.idProyecto != event.value.idProyecto;
  }

  selectPlano(event) {
    this.planoSelected = this.showPlanos.find(plano => plano.idPlano == event.value.idPlano);
    this.zonaSelected = undefined;
    this.showZonas = this.zonas.filter(zona => {
      return zona.idPlano == this.planoSelected.idPlano;
    });
  }

  selectZona(event) {
    this.zonaSelected = this.showZonas.find(zona => zona.id == event.value.id);
  }

  selectConcentradorMantenimiento(event) {
    if (event.value != "-1") {
      this.concentradorMantenimientoSelected = this.concentradoresMantenimiento.find(concentrador => concentrador.idDispositivo == event.value.idDispositivo);
    } else {
      this.concentradorMantenimientoSelected = undefined;
    }
    console.log(event)
    console.log(this.concentradorMantenimientoSelected)
  }

  removeLocation() {
    this.showZonas = [];
    this.showPlanos = [];
    this.proyectoSelected = undefined;
    this.planoSelected = undefined;
    this.zonaSelected = undefined;
  }

  checkGatewayType(concentrador: concentrador) {
    return concentrador.panId.split("x")[1].substring(0,2);
  }

  /**
   * An active gateway involved in an OTA in progress cannot be deactivated, it would interrupt the update.
   */
  isDeactivationBlocked(): boolean {
    return this.otaActive && this.activoOriginal;
  }

  isStatusLocked(): boolean {
    return this.isDeactivationBlocked() || this.activationBlocked;
  }

  getStatusLockMessage(): string {
    if (this.isDeactivationBlocked()) {
      return this.localiser.get("devices.otaActiveWarning");
    }
    if (this.activationBlocked) {
      return this.localiser.get("devices.duplicatePanIdWarning");
    }
    return "";
  }


  onCancelClick(): void {
    this.dialogRef.close(false);
  }

  onSaveClick(): void {
    let idProyectoUpdate = "-1";
    if (this.proyectoSelected != null && this.proyectoSelected != undefined) {
      idProyectoUpdate = this.proyectoSelected.idProyecto;
    }

    let idPlanoUpdate = "-1";
    if (this.planoSelected != null && this.planoSelected != undefined) {
      idPlanoUpdate = this.planoSelected.idPlano;
    }

    let idZonaUpdate = "-1";
    if (this.zonaSelected != null && this.zonaSelected != undefined) {
      idZonaUpdate = this.zonaSelected.id;
    }

    let idConcentradorMantenimientoUpdate = "-1";
    if (this.concentradorMantenimientoSelected != null && this.concentradorMantenimientoSelected != undefined) {
      idConcentradorMantenimientoUpdate = this.concentradorMantenimientoSelected.idDispositivo;
    }

    let activoUpdate = this.selectedConcentradorToEdit.activo;
    if (this.isStatusLocked() && activoUpdate != this.activoOriginal) {
      activoUpdate = this.activoOriginal;
      this.selectedConcentradorToEdit.activo = this.activoOriginal;
    }

    this.concentradorService.infoUpdate(this.selectedConcentradorToEdit.idDispositivo, this.name,
      idProyectoUpdate, idPlanoUpdate, idZonaUpdate, idConcentradorMantenimientoUpdate, activoUpdate)
      .subscribe(result => {
      this.dialogRef.close(true);
    })
  }

}
